import api from '../api';

const rtkBaseQuery =
  ({ baseUrl }) =>
  async ({ url, method = 'GET', body, params }, { signal } = {}) => {
    if (!baseUrl) {
      return { error: { status: 'CUSTOM_ERROR', data: 'BaseUrl cannot be empty!' } };
    }
    try {
      const fullUrl = baseUrl + url;
      const requestConfig = { ...(params ? { params } : {}), ...(signal ? { cancelToken: signal } : {}) };
      const result = await api.request({ method: method.toUpperCase(), url: fullUrl, data: body, ...requestConfig });
      return { data: result.data };
    } catch (err) {
      if (err?.response?.status) {
        return {
          error: {
            status: err.response.status,
            data: err.response.data || err.message,
          },
        };
      }
      return { error: { status: 'FETCH_ERROR', data: err.message } };
    }
  };

export default rtkBaseQuery;
